import React, { useContext, useEffect } from 'react';
import { AccountSettings } from '@aws-amplify/ui-react';
import { enqueueSnackbar } from 'notistack';
import { useNavigate } from 'react-router-dom';
import { Alert, Box, Card, CardContent, Stack, Typography } from '@mui/material';

import { translate as t } from 'hooks/useTranslations';
import { AppContext } from '../../context';

export default function ChangePassword() {
  const navigate = useNavigate();
  const { currentProfile, setMainNavCollapsed, setBrowserTitle } = useContext(AppContext);
  setMainNavCollapsed(true);
  if (
    !currentProfile ||
    !currentProfile.user?.authenticationType ||
    currentProfile.user?.authenticationType === 'SSO'
  ) {
    navigate('/admin/dashboard');
    return null;
  }
  const handleSuccess = () => {
    enqueueSnackbar(t('changePassword.success'), { variant: 'success' });
    navigate('/admin/dashboard');
  };
  const handleError = (error: Error) => {
    console.warn('Error changing password', error);
    enqueueSnackbar(error.message, { variant: 'error' });
  };
  useEffect(() => {
    setBrowserTitle(t('changePassword.title'));
  }, [setBrowserTitle]);

  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateRows: '1fr',
        height: '100%',
      }}
    >
      <Box
        className='change-password'
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Card sx={{ width: 400, maxWidth: '100%', p: 6 }}>
          <CardContent>
            <Stack spacing={5}>
              <Stack
                spacing={2}
                sx={{ alignItems: 'center' }}
              >
                <img
                  src='/admin/img/lexipol_logo.svg'
                  alt='Lexipol'
                  style={{ display: 'inline-block', width: 48 }}
                />
                <Typography variant='h4'>{t('changePassword.title')}</Typography>
              </Stack>
              <AccountSettings.ChangePassword
                onSuccess={handleSuccess}
                onError={handleError}
              />
              <Alert
                severity='info'
                icon={false}
              >
                <Stack>
                  <Typography>Passwords must meet the following requirements:</Typography>
                  <Box>
                    <ul>
                      <li>Be at least 12 characters long</li>
                      <li>Contain at least 1 lowercase letter</li>
                      <li>Contain at least 1 uppercase letter</li>
                      <li>Contain at least 1 number</li>
                      <li>Contain at least 1 special character like ! or @</li>
                    </ul>
                  </Box>
                </Stack>
              </Alert>
            </Stack>
          </CardContent>
        </Card>
      </Box>
    </Box>
  );
}
